import { useOrderFormAcceptanceQuery, useTosAcceptanceQuery } from '@alice-financial/alice-sdk'
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@alice-financial/pretext-ui'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined'
import * as React from 'react'
import { PageBody } from '../../routes/PageBody'
import { useOrgId } from '../useOrgId'

const DocItem = ({ name, href }: { name: string; href: string }) => {
  return (
    <ListItem disablePadding divider>
      <ListItemButton href={href} target="_blank">
        <ListItemIcon>
          <DescriptionOutlinedIcon color="primary" fontSize="large" />
        </ListItemIcon>
        <ListItemText primary={name} />
        <OpenInNewOutlinedIcon color="primary" />
      </ListItemButton>
    </ListItem>
  )
}

export const TOSAcceptanceDoc = () => {
  const orgId = useOrgId()
  const { data } = useTosAcceptanceQuery({ ownerId: orgId })
  const doc = data?.organization?.acceptance
  return (
    <DocItem
      name="Organization Terms and Conditions"
      href={doc?.signedDocument?.url || '/docs/tos-organization'}
    />
  )
}

export const OrderFormDoc = () => {
  const orgId = useOrgId()
  const { data } = useOrderFormAcceptanceQuery({ ownerId: orgId })
  const doc = data?.organization?.acceptance
  if (!doc?.signedDocument?.url) return null
  return <DocItem name="Order Form" href={doc.signedDocument.url} />
}

// Unlike other docs, the HTML for this doc is generated from a PDF, and rendered in
// full (no other admin dashboard UI) directly from the rails app. It is available
// for logged-in admins only. If working locally, you'll have to manually adjust the port
// number for it to display.
const AccountingGuideDoc = () => {
  return <DocItem name="Accounting Guide" href="/accounting_guide" />
}

export const DocumentsPage = () => {
  return (
    <PageBody maxWidth={1200}>
      <Typography variant="h1" gutterBottom>
        Documents
      </Typography>
      <List>
        <TOSAcceptanceDoc />
        <OrderFormDoc />
        <AccountingGuideDoc />
      </List>
    </PageBody>
  )
}
